import React from "react";
import orlando from "../../assets/orlando.jpg";
import miami from "../../assets/miami.jpg";
import newYork from "../../assets/new-york.jpg";
import chicago from "../../assets/chicago.jpg";

// Mock data for the locations. You can replace the image URLs with your local assets if needed.
const locationsData = [
  {
    id: 1,
    city: "Orlando",
    price: 25,
    // This will generate a reliable, high-quality 800x600 stock image
    image: orlando,
  },
  {
    id: 2,
    city: "Miami",
    price: 31,
    // Updated Miami Image
    image: miami,
  },
  {
    id: 3,
    city: "New York",
    price: 39,
    image: newYork,
  },
  {
    id: 4,
    city: "Chicago",
    price: 34,
    image: chicago,
  },
];

const TopLocations = () => {
  // Replace with your actual support phone number
  const supportPhone = "+18779910909";

  const handlePhoneClick = () => {
    if (window.gtag) {
      window.gtag("config", "AW-18343552397/3FAKCIr6l9ccEI3L8apE", {
        phone_conversion_number: "1-877-991-0909",
      });
    }
  };

  return (
    <section className="mx-auto max-w-[1580px] px-4 py-16 md:px-8">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-3">
            <svg
              className="w-6 h-6 sm:w-7 sm:h-7 text-[#091b3e]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#091b3e]">
              Top Car Rental Locations in USA
            </h2>
          </div>
          <p className="text-slate-600 text-sm sm:text-base leading-relaxed max-w-4xl">
            Explore popular city and airport car rental locations across the
            United States. Choose your preferred location and call our support
            team for rental assistance.
          </p>
        </div>

        {/* Locations Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {locationsData.map((location) => (
            <a
              key={location.id}
              href={`tel:${supportPhone}`}
              onClick={handlePhoneClick}
              className="group relative block rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 aspect-[4/3] sm:aspect-[4/3] lg:aspect-[5/4] cursor-pointer"
            >
              {/* Background Image with Zoom on Hover */}
              <img
                src={location.image}
                alt={`Car rental in ${location.city}`}
                className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700 ease-in-out"
              />

              {/* Dark Gradient Overlay for text readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#091b3e]/90 via-[#091b3e]/20 to-transparent group-hover:from-[#091b3e] group-hover:via-[#091b3e]/40 transition-colors duration-300"></div>

              {/* Hover Call Action Icon (Slides down on hover) */}
              <div className="absolute top-4 right-4 bg-white/20 backdrop-blur-md p-2.5 rounded-full opacity-0 group-hover:opacity-100 transform -translate-y-2 group-hover:translate-y-0 transition-all duration-300">
                <svg
                  className="w-5 h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>

              {/* Text Content */}
              <div className="absolute inset-x-0 bottom-0 p-5 flex justify-between items-end">
                <h3 className="text-white font-bold text-xl drop-shadow-md">
                  {location.city}
                </h3>

                <div className="text-white text-xs sm:text-sm drop-shadow-md font-medium text-right">
                  from{" "}
                  <span className="text-[#e32b22] font-extrabold text-lg sm:text-xl ml-1">
                    ${location.price}
                  </span>{" "}
                  <span className="text-white/80">/day</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopLocations;
